import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enSectionTitles from "../translate/compiled/en/sectionTitles.json";
import frSectionTitles from "../translate/compiled/fr/sectionTitles.json";

import enlabels from "../translate/compiled/en/labels.json";
import frlabels from "../translate/compiled/fr/labels.json";

import enToastValidation from "../translate/compiled/en/toastValidation.json";
import frToastValidation from "../translate/compiled/fr/toastValidation.json";

import enDropdown from "../translate/compiled/en/dropdown.json";
import frDropdown from "../translate/compiled/fr/dropdown.json";

import enAP from "../translate/compiled/en/tableHeaders/accounting/accountsPayable.json";
import enAR from "../translate/compiled/en/tableHeaders/accounting/accountsReceivable.json";
import enARP from "../translate/compiled/en/tableHeaders/accounting/ARPortal.json";
import enCAD from "../translate/compiled/en/tableHeaders/accounting/cashAppDefaults.json";
import enCCS from "../translate/compiled/en/tableHeaders/accounting/cashClearingSetup.json";
import enCIB from "../translate/compiled/en/tableHeaders/accounting/cashInBanks.json";
import enCRD from "../translate/compiled/en/tableHeaders/accounting/cashReceiptDefaults.json";
import enCOA from "../translate/compiled/en/tableHeaders/accounting/chartOfAccounts.json";
import enCRPT from "../translate/compiled/en/tableHeaders/accounting/cashReceiptPaymentTypes.json";
import enETCAC from "../translate/compiled/en/tableHeaders/accounting/ETCAbsenceCodes.json";
import enETCPP from "../translate/compiled/en/tableHeaders/accounting/ETCPayPeriod.json";
import enETCTC from "../translate/compiled/en/tableHeaders/accounting/ETCTardyCodes.json";
import enEA from "../translate/compiled/en/tableHeaders/accounting/expenseAllocations.json";
import enGLFYC from "../translate/compiled/en/tableHeaders/accounting/GLFiscalYearCalendar.json";
import enGC from "../translate/compiled/en/tableHeaders/accounting/groupCodes.json";
import enIT from "../translate/compiled/en/tableHeaders/accounting/intercoTransfer.json";
import enIAP from "../translate/compiled/en/tableHeaders/accounting/invoiceAutoPost.json";
import enJ from "../translate/compiled/en/tableHeaders/accounting/journals.json";
import enJT from "../translate/compiled/en/tableHeaders/accounting/journalTemplates.json";
import enLFT from "../translate/compiled/en/tableHeaders/accounting/laserFormTable.json";
import enODC from "../translate/compiled/en/tableHeaders/accounting/onDemandChecks.json";
import enPOCG from "../translate/compiled/en/tableHeaders/accounting/POConfigurationGroup.json";
import enPOROLI from "../translate/compiled/en/tableHeaders/accounting/PORoleLevelInfo.json";
import enPOUOM from "../translate/compiled/en/tableHeaders/accounting/POUnitsOfMeasure.json";
import enRJE from "../translate/compiled/en/tableHeaders/accounting/recurringJournalEntries.json";
import enRFM from "../translate/compiled/en/tableHeaders/accounting/remittanceFormMapping.json";
import enRTP from "../translate/compiled/en/tableHeaders/accounting/remitToParent.json";
import enSC from "../translate/compiled/en/tableHeaders/accounting/saleChains.json";
import enWO from "../translate/compiled/en/tableHeaders/accounting/writeOffs.json";
import enVC from "../translate/compiled/en/tableHeaders/accounting/vendorCategory.json";
import enVPT from "../translate/compiled/en/tableHeaders/accounting/vendorPaymentTypes.json";
import enVCT from "../translate/compiled/en/tableHeaders/accounting/VendorCompanyType.json";

import enLT from "../translate/compiled/en/tableHeaders/service/laborTypes.json";

import frAP from "../translate/compiled/fr/tableHeaders/accounting/accountsPayable.json";
import frAR from "../translate/compiled/fr/tableHeaders/accounting/accountsReceivable.json";
import frARP from "../translate/compiled/fr/tableHeaders/accounting/ARPortal.json";
import frCAD from "../translate/compiled/fr/tableHeaders/accounting/cashAppDefaults.json";
import frCCS from "../translate/compiled/fr/tableHeaders/accounting/cashClearingSetup.json";
import frCIB from "../translate/compiled/fr/tableHeaders/accounting/cashInBanks.json";
import frCRD from "../translate/compiled/fr/tableHeaders/accounting/cashReceiptDefaults.json";
import frCOA from "../translate/compiled/fr/tableHeaders/accounting/chartOfAccounts.json";
import frCRPT from "../translate/compiled/fr/tableHeaders/accounting/cashReceiptPaymentTypes.json";
import frETCAC from "../translate/compiled/fr/tableHeaders/accounting/ETCAbsenceCodes.json";
import frETCPP from "../translate/compiled/fr/tableHeaders/accounting/ETCPayPeriod.json";
import frETCTC from "../translate/compiled/fr/tableHeaders/accounting/ETCTardyCodes.json";
import frEA from "../translate/compiled/fr/tableHeaders/accounting/expenseAllocations.json";
import frGLFYC from "../translate/compiled/fr/tableHeaders/accounting/GLFiscalYearCalendar.json";
import frGC from "../translate/compiled/fr/tableHeaders/accounting/groupCodes.json";
import frIT from "../translate/compiled/fr/tableHeaders/accounting/intercoTransfer.json";
import frIAP from "../translate/compiled/fr/tableHeaders/accounting/invoiceAutoPost.json";
import frJ from "../translate/compiled/fr/tableHeaders/accounting/journals.json";
import frJT from "../translate/compiled/fr/tableHeaders/accounting/journalTemplates.json";
import frLFT from "../translate/compiled/fr/tableHeaders/accounting/laserFormTable.json";
import frODC from "../translate/compiled/fr/tableHeaders/accounting/onDemandChecks.json";
import frPOCG from "../translate/compiled/fr/tableHeaders/accounting/POConfigurationGroup.json";
import frPOROLI from "../translate/compiled/fr/tableHeaders/accounting/PORoleLevelInfo.json";
import frPOUOM from "../translate/compiled/fr/tableHeaders/accounting/POUnitsOfMeasure.json";
import frRJE from "../translate/compiled/fr/tableHeaders/accounting/recurringJournalEntries.json";
import frRFM from "../translate/compiled/fr/tableHeaders/accounting/remittanceFormMapping.json";
import frRTP from "../translate/compiled/fr/tableHeaders/accounting/remitToParent.json";
import frSC from "../translate/compiled/fr/tableHeaders/accounting/saleChains.json";
import frWO from "../translate/compiled/fr/tableHeaders/accounting/writeOffs.json";
import frVC from "../translate/compiled/fr/tableHeaders/accounting/vendorCategory.json";
import frVPT from "../translate/compiled/fr/tableHeaders/accounting/vendorPaymentTypes.json";
import frVCT from "../translate/compiled/fr/tableHeaders/accounting/VendorCompantType.json";

import frLT from "../translate/compiled/fr/tableHeaders/service/laborTypes.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      sectionTitles: enSectionTitles,
      toastValidation: enToastValidation,
      labels: enlabels,
      dropdown: enDropdown,
      AccountsPayable: enAP,
      AccountsReceivable: enAR,
      ARPortal: enARP,
      CAPDefaults: enCAD,
      CashClearingSetup: enCCS,
      CashInBanks: enCIB,
      CREDefaults: enCRD,
      PaymentTypes: enCRPT,
      EtcAbsenceCodes: enETCAC,
      COA: enCOA,
      EtcPayPeriod: enETCPP,
      EtcTardyCodes: enETCTC,
      ExpenseAllocations: enEA,
      GLFiscalYearCalendar: enGLFYC,
      GroupCodes: enGC,
      IntercoTransfer: enIT,
      InvoiceAutoPost: enIAP,
      Journals: enJ,
      JournalTemplates: enJT,
      LaserFormTable: enLFT,
      Checks: enODC,
      POConfigurationGroup: enPOCG,
      PORoleLevelInfo: enPOROLI,
      POUnitsOfMeasure: enPOUOM,
      RecurringJournalEntries: enRJE,
      RemittanceFormMapping: enRFM,
      RemitToParent: enRTP,
      SaleChains: enSC,
      WriteOffs: enWO,
      VendorCategory: enVC,
      VendorPaymentTypes: enVPT,
      VendorCompanyType: enVCT,
      LaborTypes: enLT,
    },
    fr: {
      sectionTitles: frSectionTitles,
      toastValidation: frToastValidation,
      labels: frlabels,
      dropdown: frDropdown,
      AccountsPayable: frAP,
      AccountsReceivable: frAR,
      ARPortal: frARP,
      CAPDefaults: frCAD,
      CashClearingSetup: frCCS,
      CashInBanks: frCIB,
      CREDefaults: frCRD,
      PaymentTypes: frCRPT,
      EtcAbsenceCodes: frETCAC,
      COA: frCOA,
      EtcPayPeriod: frETCPP,
      EtcTardyCodes: frETCTC,
      ExpenseAllocations: frEA,
      GLFiscalYearCalendar: frGLFYC,
      GroupCodes: frGC,
      IntercoTransfer: frIT,
      InvoiceAutoPost: frIAP,
      Journals: frJ,
      JournalTemplates: frJT,
      LaserFormTable: frLFT,
      Checks: frODC,
      POConfigurationGroup: frPOCG,
      PORoleLevelInfo: frPOROLI,
      POUnitsOfMeasure: frPOUOM,
      RecurringJournalEntries: frRJE,
      RemittanceFormMapping: frRFM,
      RemitToParent: frRTP,
      SaleChains: frSC,
      WriteOffs: frWO,
      VendorCategory: frVC,
      VendorPaymentTypes: frVPT,
      VendorCompanyType: frVCT,
      LaborTypes: frLT,
    },
  },
  lng: "en",
  fallbackLng: "en",
  ns: [
    "sectionTitles",
    "toastValidation",
    "labels",
    "dropdown",
    "AccountsPayable",
    "AccountsReceivable",
    "ARPortal",
    "CAPDefaults",
    "CashClearingSetup",
    "CashInBanks",
    "CREDefaults",
    "PaymentTypes",
    "COA",
    "EtcAbsenceCodes",
    "EtcPayPeriod",
    "EtcTardyCodes",
    "ExpenseAllocations",
    "GLFiscalYearCalendar",
    "GroupCodes",
    "IntercoTransfer",
    "InvoiceAutoPost",
    "Journals",
    "JournalTemplates",
    "LaserFormTable",
    "Checks",
    "POConfigurationGroup",
    "PORoleLevelInfo",
    "POUnitsOfMeasure",
    "POVendorChangeControl",
    "RecurringJournalEntries",
    "RemittanceFormMapping",
    "RemitToParent",
    "SaleChains",
    "WriteOffs",
    "VendorPaymentTypes",
    "VendorCategory",
    "VendorCompanyType",
    "LaborTypes",
  ],
  interpolation: { escapeValue: false },
});

export default i18n;
